import React from 'react'
import { Link } from 'react-router-dom'

export const GRNDaDAbout: React.FC = () => {
  return (
    <main
      className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16"
      data-testid="grndad-about-container"
    >
      <div className="max-w-7xl mx-auto">
        {/* Sub-navigation */}
        <nav className="mb-8 border-b border-[#3C2416]/20 pb-4">
          <div className="flex flex-wrap gap-6">
            <Link
              to="/grndad/about"
              className="text-[#A6410A] font-medium border-b-2 border-[#A6410A] pb-1"
            >
              About
            </Link>
            <Link
              to="/grndad/locations"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Locations
            </Link>
            <Link
              to="/grndad/executive-committee"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Executive Committee
            </Link>
            <Link
              to="/grndad/benefits-of-joining"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Benefits of Joining
            </Link>
            <Link
              to="/grndad/speaker-series"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Speaker Series
            </Link>
          </div>
        </nav>

        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-8">
          About GRNDaD
        </h1>

        <div className="prose prose-lg max-w-none">
          <div className="bg-white rounded-lg shadow-md p-8 mb-8">
            <h2 className="text-2xl font-semibold text-[#A6410A] mb-4">
              Globin Regional Data and Discovery
            </h2>

            <p className="text-[#3C2416] mb-6 leading-relaxed">
              Sickle Cell Disease (SCD) is a genetic anemia with debilitating
              and life-threatening sequelae. It affects 100,000 Americans, and
              millions worldwide. Research-driven improvements in pediatric care
              have successfully lengthened life expectancy in SCD over the last
              5 decades, especially in resource rich settings. Nonetheless, the
              clinical impact of the underlying pathophysiology has not been
              fully mitigated. The burden of disease in the emerging
              contemporary population, especially young adults with SCD who now
              survive childhood, is changing in significant ways that are
              largely unexplored.
            </p>

            <p className="text-[#3C2416] mb-6 leading-relaxed">
              GRNDaD is a multisite registry developed by internationally
              recognized physicians who take care of both children and adults
              with sickle cell disease. The goal is to collect longitudinal data
              on a cohort of people living with sickle cell disease to better
              understand how clinical characteristics predict outcomes. GRNDaD
              also collects patient reported outcomes including surveys on
              health related quality of life and information on pain and
              fatigue.
            </p>

            <p className="text-[#3C2416] mb-6 leading-relaxed">
              Another major goal of GRNDaD is to use the data collected for
              quality improvement and assess how sites are doing adhering to
              guideline recommendations. We then will use this information to
              develop appropriate interventions to improve adherence to
              recommendations which will lead to improved outcomes for this
              population.
            </p>

            <div className="bg-[#FDF7F2] border-l-4 border-[#A6410A] p-6 mt-8">
              <h3 className="text-lg font-semibold text-[#3C2416] mb-3">
                Interested in Joining?
              </h3>
              <p className="text-[#3C2416] mb-4">
                If you are a clinic that takes care of people living with sickle
                cell disease and would like to inquire about joining as a GRNDaD
                site, please email us at:
              </p>
              <a
                href="mailto:GRNDaDSCD@gmail.com"
                className="text-[#A6410A] font-medium hover:underline"
              >
                GRNDaDSCD@gmail.com
              </a>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-[#A6410A] mb-4">
              Research Goals
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#A6410A] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-[#3C2416]">
                    Prospectively obtain high-quality curated data on the
                    evolving population affected by SCD
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#A6410A] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-[#3C2416]">
                    Improve adherence to guideline-based care
                  </p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#A6410A] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-[#3C2416]">
                    Provide a platform for ongoing quality improvement across
                    sites
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#A6410A] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-[#3C2416]">
                    Allow for real-time investigation of therapies and
                    collaborate broadly to address research questions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
